<template>
    <div>
        <!-- my account start  -->
        <section class="main_content_area pt-30">
            <div class="container extra-view">   
                <div class="account_dashboard">
                    <div class="row">
                        <div class="col-sm-12 col-md-2 col-lg-2">
                            <!-- Nav tabs -->
                            <div class="dashboard_tab_button">
                                <ul role="tablist" class="nav flex-column dashboard-list">
                                    <li><a href="#orders" data-bs-toggle="tab" class="nav-link active">Đơn mua</a></li>
                                    <li><a href="#receipts" data-bs-toggle="tab" class="nav-link">Đơn xuất</a></li>
                                    <li><a href="#returns" data-bs-toggle="tab" class="nav-link">Trả hàng</a></li>
                                    <li><a href="#recharges" data-bs-toggle="tab" class="nav-link">Thanh toán</a></li>
                                    <li><a href="#storages" data-bs-toggle="tab" class="nav-link">Chờ xuất</a></li>
                                    <li><a href="#account-details" data-bs-toggle="tab" class="nav-link">Tài khoản</a></li>
                                    <li><a href="#" class="nav-link only-desktop" @click="logout">Đăng xuất</a></li>
                                </ul>
                            </div>    
                        </div>
                        <div class="col-sm-12 col-md-10 col-lg-10">
                            <div class="tab-content dashboard_content">
                                <account-order></account-order>
                                <account-receipt></account-receipt>
                                <account-return></account-return>
                                <account-recharge></account-recharge>
                                <account-storage></account-storage>
                                <account-detail></account-detail>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </section>
    </div>
</template>
<script>
import AccountOrders from "@/components/account/orders"
import AccountReceipts from "@/components/account/receipts"
import AccountReturns from "@/components/account/returns"
import AccountRecharges from "@/components/account/recharges"
import AccountStorages from "@/components/account/storages"
import AccountDetail from "@/components/account/detail"
export default {
    components: {
        "account-order": AccountOrders,
        "account-receipt": AccountReceipts,
        "account-return": AccountReturns,
        "account-recharge": AccountRecharges,
        "account-detail": AccountDetail,
        "account-storage": AccountStorages,
    },
    methods: {
        logout() {
            this.$root.$emit("APP_LOGOUT");
        },
    }
}
</script>